<script lang="ts">
    import IconImg from "./IconImg.svelte";
    import MailLink from "./MailLink.svelte";
    import PhoneLink from "./PhoneLink.svelte";
    import LogoIcon from "./LogoIcon.svelte";
    import Btn from "./Btn.svelte";
    import { t } from "../helpers/translation";

    const MAIN_EMAIL_ADDRESS = "kontakt@sinus-nt.de";

    const current_year = new Date().getFullYear();
</script>

<footer>
    <div class="inner">
        <div class="footer-row">
            <div class="footer-col" id="logo-col">
                <IconImg svg={LogoIcon} width="80%" color="var(--gray)" />
            </div>

            <div class="footer-col">
                <h4>{@html $t("footer.col.about.heading")}</h4>
                <a href="ueber-uns/niederlassungen#scroll-map"
                    >{@html $t("footer.col.about.gmaplink")}</a
                >
                <a href="ueber-uns/team"
                    >{@html $t("footer.col.about.link.team")}</a
                >
                <a href="ueber-uns/partner"
                    >{@html $t("footer.col.about.link.partner")}</a
                >
                <a href="ueber-uns/zertifikate"
                    >{@html $t("footer.col.about.link.certificates")}</a
                >
                <a href="ueber-uns/verbaende"
                    >{@html $t("footer.col.about.link.verbaende")}</a
                >
                <a href="karriere"
                    >{@html $t("footer.col.about.link.karriere")}</a
                >
            </div>
            <div class="footer-col">
                <h4>{@html $t("footer.col.downloads.heading")}</h4>
                <a href="https://get.teamviewer.com/6qh2xbe" target="_blank"
                    >{@html $t("footer.col.downloads.link.teamviewer")}</a
                >
                <a
                    href="https://liveicom.azureedge.net/sinus/files/Allgemeine-Lieferbedingungen.pdf"
                    target="_blank"
                    >{@html $t("footer.col.downloads.link.alf")}</a
                >
                <a
                    href="https://liveicomcdn.blob.core.windows.net/sinus/files/REPARATURAUFTRAG_2024.pdf"
                    target="_blank"
                    >{@html $t("footer.col.downloads.link.repform")}</a
                >
                <a
                    href="https://liveicomcdn.blob.core.windows.net/sinus/files/Freistellungsbescheinigung%20%C2%A748b%20EStG_05.202_1.pdf"
                    target="_blank"
                    >{@html $t("footer.col.downloads.link.freeform")}</a
                >
            </div>
            <div class="footer-col mobile-last-place">
                <h4>{@html $t("footer.col.location.ludwigsburg.heading")}</h4>
                <address>
                    {@html $t("footer.col.location.ludwigsburg.address")}
                </address>
                <MailLink text="ludwigsburg@sinus-nt.de" />
                <PhoneLink text="+49 7141 2966 0" />
            </div>

            <div class="footer-col">
                <h4>{@html $t("footer.col.location.barsbuettel.heading")}</h4>
                <address>
                    {@html $t("footer.col.location.barsbuettel.address")}
                </address>
                <MailLink text="barsbuettel@sinus-nt.de" />
                <PhoneLink text="+49 40 682875 0" />
            </div>
            <div class="footer-col">
                <h4>{@html $t("footer.col.location.greifwald.heading")}</h4>
                <address>
                    {@html $t("footer.col.location.greifwald.address")}
                </address>
                <MailLink text="greifswald@sinus-nt.de" />
                <PhoneLink text="+49 3834 3542 100" />
            </div>
            <div class="footer-col">
                <h4>{@html $t("footer.col.location.unna.heading")}</h4>
                <address>
                    {@html $t("footer.col.location.unna.address")}
                </address>
                <MailLink text="unna@sinus-nt.de" />
                <PhoneLink text="+49 2307 916402 0" />
            </div>
            <div class="footer-col">
                <h4>{@html $t("footer.col.location.pforzheim.heading")}</h4>
                <address>
                    {@html $t("footer.col.location.pforzheim.address")}
                </address>
                <MailLink text="pforzheim@sinus-nt.de" />
                <!-- <PhoneLink text="+49 7231 46940 10" /> -->
            </div>
        </div>
    </div>
    <div class="bottom-bar">
        {@html $t("footer.bottombar.copyright")}
        {current_year}
        |
        <a href="impressum">{@html $t("footer.bottombar.link.imprint")}</a>
        |
        <a href="datenschutz">{@html $t("footer.bottombar.link.privacy")}</a>
        |
        <a href="hinweisgeberschutz"
            >{@html $t("footer.bottombar.link.hinweisgeberschutz")}</a
        >
    </div>
</footer>

<style lang="scss">
    @import "../vars";

    #logo-col {
        :global(*) {
            color: $gray;
            fill: $gray;
        }
    }

    .mobile-last-place {
        @media (max-width: 768px) {
            order: 999;
        }
    }
    footer {
        width: 100%;
        background-color: $grayDark2;
        font-size: 1rem;
        margin-top: 4rem;
        h4 {
            color: $grayLight;
            font-size: 1.5em;
            margin: 0;
            margin-bottom: 0.5em;
        }
        address {
            color: $grayLight;
            font-style: unset;
            margin: 1em 0;
        }

        :global(.icon-link) {
            margin: 0.25em 0em;
        }

        .inner {
            max-width: 1600px;
            padding: 4em 1em;
            .footer-row {
                overflow-x: hidden;
                width: 100%;
                transform: translateX(-4px);
                display: grid;
                grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
            }
            margin: auto;
            // prettier-ignore
            .footer-col {
                transform: translateX(4px);
                padding: 1em 2em;
                border-right: 1px solid $gray;
                margin-bottom: 2em;
                a {
                    margin-bottom: 0.5em;
                }

                &:last-child {
                    border: none !important
                }
            

                >:global(*) {
                    display: block !important;
                }
            }
        }
    }
    .bottom-bar {
        padding: 1em;
        text-align: center;
        background-color: $grayDark;
        color: white;
        font-size: 0.8em;
    }
</style>
